export function convertArrayToMap(array) {
  return array.reduce((acc, curr) => {
    acc[curr.value] = curr.label;
    return acc;
  }, {});
}
